<template>
    <div :style="style" class="all">
        <div class="head">
            <span v-html="$getConfigText(block.inner.title)"></span>
        </div>
        <div class="content">
            <span v-html="$getConfigText(block.inner.content)"></span>
        </div>
    </div>
</template>
 
<style lang='scss' scoped>
    .all{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 40px;
        .head{
            margin-top: 1.07rem;
            margin-bottom: 1.07rem;
            font-size: 0.64rem;
            line-height: 1.4;
            font-weight: bold;
        }
        .content{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 8.93rem;
            font-size: 0.37rem;
            line-height: 0.69rem;
            color:#333;
            text-align: center;
        }
    }
</style>
    
<script>
export default {
    name:'MContactUs',
    props:{
        block:Object,
    },
    computed:{
        style(){
            return `background-color:${this.block.backColor};
                    color:${this.block.fontColor}`
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/templates/m-blocks/contact-us.vue